import React from "react"

const Break = () => <hr className="my-4" />

const SectionHeading = ({ title }) => {
  return <h6 className="heading-small text-muted mb-4">{title}</h6>
}

export default function Section({ title, children, className }) {
  return (
    <>
      <SectionHeading title={title} />
      <div className={className || "pl-lg-4"}>{children}</div>
      <Break />
    </>
  )
}
